import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconThirdPartyPrimhd = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.73 14.627 7.8 21H4L6.608 3h6.482q1.813 0 3.109.373 1.311.361 2.15 1.021.84.66 1.238 1.569.413.896.413 1.979 0 1.444-.545 2.676a5.7 5.7 0 0 1-1.606 2.116q-1.076.884-2.696 1.395-1.606.498-3.757.498zm1.34-9.137-.972 6.622h2.681q1.12 0 1.945-.286.825-.287 1.37-.797.545-.523.796-1.232.264-.71.265-1.569 0-.61-.207-1.12a2.1 2.1 0 0 0-.633-.859 3 3 0 0 0-1.076-.56q-.633-.2-1.517-.2z"
      clipRule="evenodd"
    />
  </NcIcon>
);
export { NcIconThirdPartyPrimhd };
